export default {
  GET_AGES: 'OTT/railways/ages/GET_AGES',
  GET_AGES_SUCCESS: 'OTT/railways/ages/GET_AGES_SUCCESS',
  GET_AGES_FAIL: 'OTT/railways/ages/GET_AGES_FAIL',
};
